import React, { Component } from 'react'
import { StaticQuery, graphql } from "gatsby"
import ContentFront from '../Layout/ContentFront'

class Recall extends Component {
  render() {
    return (
      <StaticQuery
        query={ graphql`
          query {
            allNodeRepair(filter: {promote: {eq: true}}, limit: 2, sort: {fields: created, order: DESC}) {
              edges {
                node {
                  id
                  title
                  displayDate: created(formatString: "MM/DD/Y")
                  path {
                    alias
                  }
                  field_teaser
                  relationships {
                    featuredImage: field_image {
                      localFile {
                        childImageSharp {
                          fluid(maxWidth: 125, maxHeight: 125, quality: 100) {
                            ...GatsbyImageSharpFluid_withWebp
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `}

        render={data => (
          <section>
            {data.allNodeRepair.edges.map(repair => (
              <>
                <ContentFront data={repair.node} title="repair" link="/repairs" />
              </>
            ))}
          </section>
        )}
      />
    )
  }
}

export default Recall